export const enforceThreeDecimalFormat = (e) => {
    const { value } = e.target;

    // Remove all non-numeric and non-dot characters
    let cleaned = value.replace(/[^\d.]/g, '');

    // Allow only one dot
    const parts = cleaned.split('.');
    if (parts.length > 2) {
        cleaned = parts[0] + '.' + parts[1];
    }

    // Format to fixed 3 decimals only if user enters a dot
    if (cleaned.includes('.')) {
        const [whole, decimal = ''] = cleaned.split('.');
        cleaned = whole + '.' + decimal.slice(0, 3);
    }

    e.target.value = cleaned;
};

export const enforceMoneyFormat = (e) => {
    let val = e.target.value.replace(/,/g, '').replace(/[^\d.]/g, '');

    // Limit to 1 decimal point
    const parts = val.split('.');
    if (parts.length > 2) {
        val = parts[0] + '.' + parts[1];
    }

    // Force 2 decimal places
    let number = parseFloat(val);
    if (!isNaN(number)) {
        // Format to 2 decimals and add commas
        val = number.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    } else {
        val = '';
    }

    e.target.value = val;
};

export const enforceNumericFormat = (e) => {
    e.target.value = e.target.value.replace(/\D/g, '');
};



export const toEncompassInteger = (val) => {
  const s = (val ?? "").toString().trim();
  if (!s) return "";

  // remove commas, parse number, then drop decimals
  const n = Number.parseFloat(s.replace(/,/g, ""));
  if (Number.isNaN(n)) return "";

  return Math.trunc(n).toString(); // 450000.00 -> "450000"
};
